export default __webpack_public_path__ + "static/media/Todo.5c016b62.svg";